import React, { useState, useEffect } from 'react';
// import Sidebar from '../../components/Sidebar';
import AlertMessage from '../../AlertMessage';

const DropdownExample = () => {
  const [selectedDay, setSelectedDay] = useState(''); 
  const [savedMenus, setSavedMenus] = useState([]); // State to hold multiple saved menus
  const [selectedMenu, setSelectedMenu] = useState(null); // Track the currently selected menu
  const [selectedAaharMenu, setSelectedAaharMenu] = useState('');
  const [inputValue, setInputValue] = useState('');
  const [selectedFoodItems, setSelectedFoodItems] = useState([]);
  const [isMenuSaved, setIsMenuSaved] = useState(false);
  const [isOtherOption, setIsOtherOption] = useState(false);
  const [menuData, setMenuData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  
  const udiseNumber = localStorage.getItem("udiseNumber");
  const [schoolData, setSchoolData] = useState(null); 

  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  useEffect(() => {
      if (alertMessage) {
        setShowAlert(true);
        const timeoutId = setTimeout(() => {
          setShowAlert(false);
          setAlertMessage(""); 
        }, 3000);
        return () => clearTimeout(timeoutId);
      }
    }, [alertMessage]);



    

const language = localStorage.getItem("language");

const dayOptions = [
  { value: 'Monday', label: language === "English" ? 'Monday' : 'सोमवार', selectable: true },
  { value: 'Tuesday', label: language === "English" ? 'Tuesday' : 'मंगळवार', selectable: true },
  { value: 'Wednesday', label: language === "English" ? 'Wednesday' : 'बुधवार', selectable: true },
  { value: 'Thursday', label: language === "English" ? 'Thursday' : 'गुरुवार', selectable: true },
  { value: 'Friday', label: language === "English" ? 'Friday' : 'शुक्रवार', selectable: true },
  { value: 'Saturday', label: language === "English" ? 'Saturday' : 'शनिवार', selectable: true },
  { value: 'Sunday', label: language === "English" ? 'Sunday' : 'रविवार', selectable: false }, 
];

const getDropdownOptions = (menuData) => {
  const options = [];
  const days = [...dayOptions]; // Use the dayOptions defined above
  options.push(<option key="spacer " value="" disabled>── {language==="English" ?'First And Third Week':'पहिला आणि तिसरा आठवडा'} ──</option>);
  // First week
  for (let i = 1; i <= 6; i++) { // Adjusted to 6 since Sunday is removed
    const day = days[i - 1];
    const menu = menuData && menuData[day.value] ? ` - ${menuData[day.value]}` : ''; // Check if menu exists
    options.push(
      <option key={i} value={`${i}. ${day.value}`} disabled={!day.selectable} style={{ color: day.selectable ? 'black' : 'lightgray' }}>
        {`${i}. ${day.label}${menu}`}
      </option>
    );
  }

  // Spacer
  options.push(<option key="spacer " value="" disabled>── {language==="English" ?'Second And Fourth Week':'दुसरा आणि चौथा आठवडा'} ──</option>);

  // Second week
  for (let i = 7; i <= 12; i++) { // Adjusted to 12 since Sunday is removed
    const day = days[i - 7]; // Adjust index for second week
    const menu = menuData && menuData[day.value] ? ` - ${menuData[day.value]}` : ''; // Check if menu exists
    options.push(
      <option key={i} value={`${i}. ${day.value}`} disabled={!day.selectable} style={{ color: day.selectable ? 'black' : 'lightgray' }}>
        {`${i}. ${day.label}${menu}`}
      </option>
    );
  }

  return options;
};


const getFoodItemLabel = (foodItem) => {
    const option = aaharMenuOptions.find(option => option.value === foodItem);
    return option ? option.label : foodItem; // Return the Marathi label or the original if not found
};

const aaharMenuOptions = [
  { value: 'Vegetable Pulav', label: language === "English" ? 'Vegetable Pulav' : 'व्हेजिटेबल पुलाव' },
  { value: 'Masale Bhat', label: language === "English" ? 'Masala Rice' : 'मसाले भात' },
  { value: 'Matar Pulav', label: language === "English" ? 'Matar Pulav' : 'मटर पुलाव' },
  { value: 'Mungdal Khichadi', label: language === "English" ? 'Mungdal Khichadi' : 'मुगडाळ खिचडी' },
  { value: 'Chawali Khichadi', label: language === "English" ? 'Cowpea Khichadi' : 'चवळी खिचडी' },
  { value: 'Chana Pulav', label: language === "English" ? 'Chana Pulav' : 'चना पुलाव' },
  { value: 'Soyabin Pulav', label: language === "English" ? 'Soyabin Pulav' : 'सोयाबीन पुलाव' },
  { value: 'Masuri Pulav', label: language === "English" ? 'Masuri Pulav' : 'मसुरी पुलाव' },
  { value: 'Anda Pulav', label: language === "English" ? 'Egg Pulav' : 'अंडा पुलाव' },
  { value: 'Sprouted Matki Usal', label: language === "English" ? 'Sprouted Matki Usal' : 'मोड आलेल्या मटकीची उसळ' },
  { value: 'Sweet Khichadi', label: language === "English" ? 'Sweet Khichadi' : 'गोड खिचडी' },
  { value: 'Mug Shevaga Varan Bhat', label: language === "English" ? 'Mug Shevaga Varan Bhat' : 'मूग शेवगा वरण भात' },
  { value: 'Tandalachi Kheer', label: language === "English" ? 'Rice pudding' : 'तांदळाची खीर' },
  { value: 'Nachaniche Satv', label: language === "English" ? 'ragi porridge' : 'नाचणीचे सत्व' },
  { value: 'Mod Alele Kaddhany', label: language === "English" ? 'Sprouted pulses' : 'मोड आलेले कडधान्य' },
  { value: 'Other', label: language === "English" ? 'Other' : 'इतर' },
];

const foodItems = [
  { name: language === "English" ? 'Rice' : 'तांदूळ' },
  { name: language === "English" ? 'Mugdal' : 'मुगडाळ' },
  { name: language === "English" ? 'Turdal' : 'तूरडाळ' },
  { name: language === "English" ? 'Masurdal' : 'मसूरडाळ' },
  { name: language === "English" ? 'Matki' : 'मटकी' },
  { name: language === "English" ? 'Moong' : 'मूग' },
  { name: language === "English" ? 'Cowpea' : 'चवळी' },
  { name: language === "English" ? 'Gram' : 'हरभरा' },
  { name: language === "English" ? 'Pease' : 'वाटाणा' },
  { name: language === "English" ? 'Mustard' : 'मोहरी' },
  { name: language === "English" ? 'Cumin' : 'जिरे' },
  { name: language === "English" ? 'Turmeric' : 'हळद' },
  { name: language === "English" ? 'Oil' : 'तेल' },
  { name: language === "English" ? 'Salt' : 'मीठ' },
  { name: language === "English" ? 'Onion Garlic Masala' : 'कांदा लसूण मसाला' },
  { name: language === "English" ? 'Garam Masala' : 'गरम मसाला' },
  { name: language === "English" ? 'Chili' : 'मिरची' },
  { name: language === "English" ? 'Vegetables' : 'भाजी पाला' },


  { name: language === "English" ? 'Milk-Milk Powder' : 'दूध-दूध पावडर' },
  { name: language === "English" ? 'Sugar-Jaggery' : 'साखर-गूळ' },
  { name: language === "English" ? 'Soyabean Wadi' : 'सोयाबीन वडी' },
  { name: language === "English" ? 'Ragi Satva' : 'नाचणी सत्व' },
];

const daysOfWeek = [
  { key: '1', label: language === "English" ? "Monday" : "सोमवार" },
  { key: '2', label: language === "English" ? "Tuesday" : "मंगळवार" },
  { key: '3', label: language === "English" ? "Wednesday" : "बुधवार" },
  { key: '4', label: language === "English" ? "Thursday" : "गुरुवार" },
  { key: '5', label: language === "English" ? "Friday" : "शुक्रवार" },
  { key: '6', label: language === "English" ? "Saturday" : "शनिवार" },
  { key: '7', label: language === "English" ? "Monday" : "सोमवार" }, // For second week
  { key: '8', label: language === "English" ? "Tuesday" : "मंगळवार" },
  { key: '9', label: language === "English" ? "Wednesday" : "बुधवार" },
  { key: '10', label: language === "English" ? "Thursday" : "गुरुवार" },
  { key: '11', label: language === "English" ? "Friday" : "शुक्रवार" },
  { key: '12', label: language === "English" ? "Saturday" : "शनिवार" },
];




    useEffect(() => {
      if (selectedDay) {
        const dayIndex = parseInt(selectedDay.split('.')[0], 10);
        let week = dayIndex <= 7 ? 'firstWeek' : 'secondWeek';
  
        const url = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/poshanaahar/menu/${week}/${dayIndex}.json`;
  
        fetch(url)
          .then(response => response.json())
          .then(data => {
            if (data) {
              const menus = Object.keys(data).map(menuKey => ({
                name: menuKey,
                items: Object.keys(data[menuKey]),
              }));
              setSavedMenus(menus);
            } else {
              setSavedMenus([]);
            }
          })
          .catch(error => {
            console.error('Error fetching data: ', error);
          });
      }
    }, [selectedDay, udiseNumber]);

    const handleSaveOrUpdate = () => {
      if (selectedDay && selectedFoodItems.length > 0) {
        const menuToSave = selectedAaharMenu === 'Other' ? inputValue : selectedAaharMenu;
    
        const dataToSave = {
          [menuToSave]: selectedFoodItems.reduce((acc, food) => {
            acc[food] = true;
            return acc;
          }, {}),
        };
    
        const dayIndex = parseInt(selectedDay.split('.')[0], 10);
        let week = dayIndex <= 6 ? 'firstWeek' : 'secondWeek';

    
        const url = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/poshanaahar/menu/${week}/${dayIndex}.json`;
    
        fetch(url)
          .then(response => response.json())
          .then(existingData => {
            // Merge existing data with new data
            const updatedData = { ...existingData, ...dataToSave };
    
            // Save the merged data back to the database
            return fetch(url, {
              method: 'PUT',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(updatedData),
            });
          })
          .then(response => response.json())
          .then(data => {
            setAlertMessage('Data saved successfully!');
            // window.location.reload();
          })
          .catch(error => {
            console.error('Error saving/updating data: ', error);
          });
      } else {
        setAlertMessage('Please select all fields and food items.');
      }
    };


     const DB_NAME = 'SchoolManagementDB';
    const SCHOOL_STORE = 'schoolData';
    const DB_VERSION = 1;



const openDB = () => {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);

    request.onerror = (event) => {
      console.error("IndexedDB error:", event.target.error);
      reject(event.target.error);
    };

    request.onsuccess = (event) => {
      const db = event.target.result;
      if (!db) {
        console.error("Error: db object is not initialized");
        reject("Error: db object is not initialized");
      } else {
        resolve(db);
      }
    };

    request.onupgradeneeded = (event) => {
      const db = event.target.result;

    
      if (!db.objectStoreNames.contains(SCHOOL_STORE)) {
        db.createObjectStore(SCHOOL_STORE, { keyPath: "udiseNumber" });
      }
    };
  });
};

  
     const fetchSchoolData = async () => {
  try {
    const db = await openDB();
    const transaction = db.transaction(SCHOOL_STORE, "readonly");
    const store = transaction.objectStore(SCHOOL_STORE);
    const udise = localStorage.getItem("udiseNumber");
    const request = store.get(udise);

    return new Promise((resolve) => {
      request.onsuccess = (event) => {
        const data = event.target.result;
        if (data) {
          console.log("School data from IndexedDB:", data);
          setSchoolData(data);
          resolve(data);
        } else {
          console.log("No school data found in IndexedDB, fetching from Firebase");
        }
      };

      request.onerror = (event) => {
        console.error("Error fetching school data from IndexedDB:", event.target.error);
      };
    });
  } catch (error) {
    console.error("Error accessing IndexedDB:", error);
  }
};

          useEffect(() => {
            fetchSchoolData(); 
          }, []); 

  const handleAaharMenuChange = (e) => {
    const selectedValue = e.target.value;
    setSelectedAaharMenu(selectedValue);
    setIsOtherOption(selectedValue === 'Other');
    
    // Find the selected menu from savedMenus
    const selectedMenu = savedMenus.find(menu => menu.name === selectedValue);
    
    if (selectedMenu) {
        // If the menu is found, set the selected food items to those of the selected menu
        setSelectedFoodItems(selectedMenu.items);
        setIsMenuSaved(true);
    } else {
        // If no menu is found, clear the selected food items
        setSelectedFoodItems([]);
        setIsMenuSaved(false);
    }

    // Reset inputValue if the user changes the menu back from 'Other'
    if (selectedValue !== 'Other') {
        setInputValue('');
    }
};


  const handleFoodItemChange = (foodName) => {
    setSelectedFoodItems((prevSelectedItems) =>
      prevSelectedItems.includes(foodName)
        ? prevSelectedItems.filter((item) => item !== foodName)
        : [...prevSelectedItems, foodName]
    );
  };

  const handleReport = async () => {
    // Fetch menu data for the selected class
    const firstWeekResponse = await fetch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/poshanaahar/menu/firstWeek.json`);
    const secondWeekResponse = await fetch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/poshanaahar/menu/secondWeek.json`);
  
    const firstWeekData = await firstWeekResponse.json();
    const secondWeekData = await secondWeekResponse.json();
  
    // Set the menu data for both weeks
    setMenuData({ firstWeek: firstWeekData, secondWeek: secondWeekData });
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false); 
  };

  const handlePrint = () => {
    const printContent = document.querySelector('.modal-content');
  
    if (printContent) {
      const cloneContent = printContent.cloneNode(true);
  
      const schoolName = cloneContent.querySelector('p');
      const otherDetails = cloneContent.querySelectorAll('p');
  
      otherDetails.forEach((p, index) => {
        if (index !== 0) {
          p.style.fontWeight = 'normal';
        }
      });
  
      if (schoolName) {
        schoolName.innerHTML = `<h5 style="font-size: 16px; margin-top: 10px;">${schoolData.schoolName}</h5>`;
      }
  
      const printWindow = window.open('', '', 'height=600,width=830');
      printWindow.document.write(`
        <html>
          <head>
            <title>Print Modal Content</title>
            <style>
              @page {
                size: A4 portrait;
                margin: 3mm;
              }
              body {
                font-family: Arial, sans-serif;
                margin: 0;
              }
              table {
                width: 100%;
                border-collapse: separate; /* Change to separate */
                border-spacing: 0; /* No spacing */
                margin: 0;
              }
              th, td {
                border: 1px solid black; /* Ensure borders are applied */
                padding: 12px;
                text-align: center;
              }
              thead {
                background-color: #F0F0F0;
              }
              th:nth-child(1) {
                width: 10%; /* First column width */
              }
              th:nth-child(2) {
                width: 20%; /* Second column width */
              }
              th:nth-child(3) {
              padding: 0;
              margin:0;
                width: 70%; /* Third column width */
              }
            </style>
          </head>
          <body>
            ${cloneContent.outerHTML}
          </body>
        </html>
      `);
      printWindow.document.close();
      printWindow.focus();
      printWindow.print();
      printWindow.close();
    } else {
      console.error('Print content not found');
    }
  };
 const handleDeleteMenu = (menuName) => {
    const dayIndex = parseInt(selectedDay.split('.')[0], 10);
    let week = dayIndex <= 7 ? 'firstWeek' : 'secondWeek';

    const url = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/poshanaahar/menu/${week}/${dayIndex}/${menuName}.json`;

    fetch(url, {
      method: 'DELETE',
    })
    .then(response => response.json())
    .then(data => {
      setAlertMessage('Menu deleted successfully!');
      setSavedMenus(prevMenus => prevMenus.filter(menu => menu.name !== menuName)); // Remove from local state
    })
    .catch(error => {
      console.error('Error deleting menu: ', error);
    });
  };
  const handleEditMenu = (menu) => {
    setSelectedAaharMenu(menu.name);
    setSelectedFoodItems(menu.items);
    setIsMenuSaved(true);
    setInputValue(menu.name === 'Other' ? menu.name : '');
    setIsOtherOption(menu.name === 'Other');
  };

const halfway = Math.ceil(foodItems.length / 2);
const firstColumnItems = foodItems.slice(0, halfway);
const secondColumnItems = foodItems.slice(halfway);
const inputStyle = {
  marginTop: '10px',
  width: '130px',
  maxWidth: '300px',
  height:'35px', 
  marginRight: '20px', 
  fontSize:'14px', 
  padding:'8px',
  borderRadius:'5px',
  border:'1px solid gray'
};

const buttonStyle = {
  marginTop: '20px',
  padding: '8px 20px',
  fontSize: '14px',
  backgroundColor: '#4CAF50',
  color: 'white',
  border: 'none',
  borderRadius: '4px',
  cursor: 'pointer'
};
const buttonStyleReport = {
  marginTop: '20px',
  padding: '8px 20px',
  fontSize: '14px',
  backgroundColor: '#d4a017',
  color: 'white',
  border: 'none',
  borderRadius: '4px',
  cursor: 'pointer'
};

  return (
    <div>
    {/* <Sidebar /> */}
    
 <AlertMessage message={alertMessage} show={showAlert}/>
    <div className="main-content-of-page" >
    <div style={{ maxWidth: "800px", margin: "1% auto", padding: "30px", boxShadow: "rgba(0, 0, 0, 0.2) 0px 4px 8px",  borderRadius: "5px", backgroundColor: "rgb(255, 255, 255)", border: "1px solid gray"}}>
      <h3  className='text-center mb-5' style={{ color:'#03365e', fontWeight:'600'}}>  {language === "English" ? " Food Menu  " : " आहार मेनू "}</h3>
      
      <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
       

        <div>
  <label style={{ marginBottom: '5px', fontSize: '14px' }}>{language === "English" ? " Day " : "वार "}: </label>
  <select style={inputStyle} value={selectedDay} onChange={(e) => setSelectedDay(e.target.value)}>
    <option value="">{language === "English" ? " Select Day " : "वार निवडा"}</option>
    {getDropdownOptions(menuData)}
  </select>
</div>

        <div>
          <label style={{ marginBottom: '5px', fontSize:'14px'}}>{language === "English" ? " Menu  " : " मेनू "}:</label>
          <select style={inputStyle} value={selectedAaharMenu} onChange={handleAaharMenuChange}>
            <option value="">{language === "English" ? " Select Menu   " : "मेनू निवडा"}</option>
            {aaharMenuOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      </div>

      {isOtherOption && (
        <div style={{ marginBottom: '25px', alignItems:'center', display: 'flex', justifyContent: 'center',}}>
          <label style={{  fontSize:'14px'}}>{language === "English" ? " Other Menu content  " : "इतर मेनू सामग्री "}:</label>
          <input  style={inputStyle} type="text" value={inputValue} onChange={(e) => setInputValue(e.target.value)} />
        </div>
      )}
      <div>
  {savedMenus.length > 0 && (
    <h6>{language === "English" ? " Menus" : "मेनू"}</h6>
  )}
  <hr/>
  {savedMenus.length > 0 ? (
    savedMenus.map(menu => {
      const menuOption = aaharMenuOptions.find(option => option.value === menu.name);
      const displayName = menuOption ? menuOption.label : menu.name; // Get the label based on language
      return (
        <div key={menu.name} style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
          <strong style={{ flexGrow: 1 , fontSize:'14px'}}>{displayName}</strong>
          <div style={{ display: 'flex', gap: '2px', marginRight:'60%' }}> {/* Reduced gap for buttons */}
            <button onClick={() => handleEditMenu(menu)} style={buttonStyle2}>Edit</button>
            <button onClick={() => handleDeleteMenu(menu.name)} style={{ ...buttonStyle2, backgroundColor: 'red' }}>Delete</button>
          </div>
        </div>
      );
    })
  ) : (
    " "
  )}
</div>

      <hr/>

      <div style={{
  display: 'flex',
  justifyContent: 'center',
  gap: '10%',
  padding: '35px',
  width: '100%',
  boxSizing: 'border-box',
  backgroundColor: 'rgb(242, 242, 242)',
  border: '1px solid black', // Add border here
  borderRadius: '5px',      // Optional: Add border radius for rounded corners
  transition: 'transform 0.3s ease', // Smooth transition for scale effect
  ':hover': {
    transform: 'scale(1.02)', // Slightly increase size on hover
  }
}}>
  <div style={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  }}>
    {firstColumnItems.map((item) => (
      <div key={item.name} style={{
        display: 'flex',
        alignItems: 'center',
        marginBottom: '10px',
      }}>
        <input
          type="checkbox"
          checked={selectedFoodItems.includes(item.name)}
          onChange={() => handleFoodItemChange(item.name)}
          style={{ width: '18px', height: '18px', marginRight: '10px' }}
        />
        <label style={{ marginLeft: '5px', fontSize: '15px' }}>{item.name}</label>
      </div>
    ))}
  </div>

  <div style={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  }}>
    {secondColumnItems.map((item) => (
      <div key={item.name} style={{
        display: 'flex',
        alignItems: 'center',
        marginBottom: '10px',
      }}>
        <input
          type="checkbox"
          checked={selectedFoodItems.includes(item.name)}
          onChange={() => handleFoodItemChange(item.name)}
          style={{ width: '18px', height: '18px', marginRight: '10px' }}
        />
        <label style={{ marginLeft: '5px', fontSize: '15px' }}>{item.name}</label>
      </div>
    ))}
  </div>
</div>



  <div style={{ display: 'flex',justifyContent: 'space-between', margin:'auto 180px' }}>
    <button style={buttonStyle} onClick={handleSaveOrUpdate}>
      {isMenuSaved ? 'Update' : 'Save'}
    </button>
  
    <button
      type="button"
      onClick={handleReport}
      style={buttonStyleReport}
    >
      Report
    </button>

   
  </div>

  

      </div>

      {showModal && (
          <div style={{
            position: 'fixed',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.6)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: '1000',
          }}>

            <div style={{
              backgroundColor: '#fff',
              padding: '30px',
              borderRadius: '10px',
              width: '80%',
              maxWidth: '800px', // Set a max width for better fitting
              boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)',
              maxHeight: '90%',
              overflowY: 'auto',
              position: 'relative',
            }}>

              <div className="modal-content">
            
                <table style={{
                  width: '100%',
                  borderCollapse: 'collapse',
                  marginBottom: '30px',
                  fontFamily: 'Arial, sans-serif',
                  border: '1px solid black',
                  borderRadius: '10px',
                  boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
                }}>
                  {/* Header as part of the Table */}
                  <thead>
                    {schoolData && (
                      <tr>
                        <th colSpan="3" style={{
                          color: 'black',
                          padding: '5px',
                          borderRadius: '10px 10px 0 0',
                          textAlign: 'center',
                          lineHeight: '0.4',
                          borderBottom: '1px solid black',
                          borderLeft: '1px solid black',
                          borderRight: '1px solid black',
                          borderTop: '1px solid black',
                          fontSize: '13px'
                        }}>
                          <p><strong><h5> {schoolData.schoolName}</h5></strong></p>
                          <p>{schoolData.sansthaName}</p>
                          <p>{language === "English" ? "Taluka:" : "तालुका:"} {schoolData.taluka} , {language === "English" ? "Jilha:" : "जिल्हा:"} {schoolData.jilha} </p>
                          <p>{language === "English" ? "Mobile Number:" : "मोबाइल नंबर:"} {schoolData.mobileNumber} , {language === "English" ? "Email:" : "ईमेल:"} {schoolData.email}</p>

                          <p style={{ display: 'inline-block', backgroundColor: 'black', color: 'white', padding: '10px', borderRadius: '5px', fontSize: '18px' }}>
                            {language === "English" ? "Food Menu" : "आहार मेनू "}
                          </p>
                        </th>
                      </tr>
                    )}
                    <tr style={{ color: 'black' }}>
                      <th style={{borderLeft: '1px solid black',color: 'black',...tdstylemy}}>{language === "English" ? "Day" : "वार"}</th>
                      <th style={{...tdstylemy,color: 'black'}}>{language === "English" ? "Food" : "आहार"}</th>
                      <th className='lastclumntapshil' style={{...tdstylemy, width: '40%',color: 'black'}}>{language === "English" ? "Details" : "तपशील"}</th>
                    </tr>
                  </thead>

                  <tbody>
  <tr>
    <td colSpan={3} style={{ fontSize: '18px', color: 'gray' }}>
      {language === "English" ? "First And Third Week" : "पहिला आणि तिसरा आठवडा"}
    </td>
  </tr>
  {Object.keys(menuData.firstWeek || {}).length > 0 &&
  Object.keys(menuData.firstWeek).filter(dayKey => dayKey >= 1 && dayKey <= 6) // Filter to include only valid first week days
    .map(dayKey => {
      const foods = menuData.firstWeek[dayKey];
      
      // Check if the foods data for this day exists
      if (!foods) {
        return null; // Skip if foods data is missing or invalid
      }

      const dayLabel = daysOfWeek.find(day => day.key === dayKey)?.label || dayKey;

      const foodItems = Object.keys(foods).map(menuName => {
        const food = foods[menuName];

        // Check if the menu item has ingredients and if those ingredients are valid
        if (!food) {
          return null; // Skip if food data is missing or invalid
        }

        const ingredients = Object.keys(food)
          .filter(ingredient => food[ingredient]) // Only include ingredients that are true
          .join(', '); // Join ingredients into a string

        return { menuName, ingredients }; // Return an object with menu name and ingredients
      }).filter(item => item); // Remove any null items in case some menu items were invalid

      if (foodItems.length === 0) {
        return null; // Skip if no valid food items exist for this day
      }

      return (
        <React.Fragment key={dayKey}>
          <tr>
            <td rowSpan={foodItems.length + 1}>{dayLabel}</td> {/* Displaying the day label */}
          </tr>
          {foodItems.map(({ menuName, ingredients }) => (
            <tr key={menuName}>
              <td>{getFoodItemLabel(menuName)}</td> {/* Displaying menu name */}
              <td className='lastclumntapshil'>{ingredients || '-'}</td> {/* Displaying ingredients or '-' if none */}
            </tr>
          ))}
        </React.Fragment>
      );
    })
}


  <tr>
    <td colSpan={3} style={{ fontSize: '18px', color: 'gray' }}>
      {language === "English" ? "Second And Fourth Week" : "दुसरा आणि चौथा आठवडा"}
    </td>
  </tr>

  {Object.keys(menuData.secondWeek || {})
    .filter(dayKey => dayKey >= 7 && dayKey <= 12) // Filter to include only valid second week days
    .map(dayKey => {
      const foods = menuData.secondWeek[dayKey];
      const dayLabel = daysOfWeek.find(day => day.key === dayKey)?.label || dayKey;

      // Create an array to hold the food items for this day
      const foodItems = Object.keys(foods).map(menuName => {
        const ingredients = Object.keys(foods[menuName])
          .filter(ingredient => foods[menuName][ingredient]) // Only include ingredients that are true
          .join(', '); // Join ingredients into a string

        return { menuName, ingredients }; // Return an object with menu name and ingredients
      });

      return (
        <React.Fragment key={dayKey}>
          <tr>
            <td rowSpan={foodItems.length + 1}>{dayLabel}</td> {/* Displaying the day label */}
          </tr>
          {foodItems.map(({ menuName, ingredients }) => (
            <tr key={menuName}>
              <td>{getFoodItemLabel(menuName)}</td> {/* Displaying menu name */}
              <td className='lastclumntapshil'>{ingredients || '-'}</td> {/* Displaying ingredients or '-' if none */}
            </tr>
          ))}
        </React.Fragment>
      );
    })}
</tbody>
                </table>
              </div>

              <div style={{ textAlign: 'right', marginTop: '20px' }}>

                <button onClick={handlePrint} style={{
          padding: '12px 25px',
          backgroundColor: '#007BFF',
          color: '#fff',
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer',
          fontSize: '16px',
          boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
          transition: 'background-color 0.2s ease',
          marginRight: '10px',
        }}>
         {language === "English" ? "Print" : "प्रिंट करा"} 
        </button>

                <button onClick={closeModal} style={{
                  padding: '12px 25px',
                  backgroundColor: '#FF4136',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  fontSize: '16px',
                  boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
                  transition: 'background-color 0.2s ease',
                }}
                  onMouseOver={(e) => e.target.style.backgroundColor = '#E04A3F'}
                  onMouseOut={(e) => e.target.style.backgroundColor = '#FF4136'}
                >
               {language === "English" ? "Close" : " बंद करा"}                          
                </button>
              </div>
            </div>
          </div>
        )}

      </div>
    </div>
  );
};


const tdstylemy={
  padding: '10px',
  fontWeight: 'bold',
  borderBottom: '1px solid black',
  textAlign: 'center',
  borderRight: '1px solid black',
}
const buttonStyle2={
  padding: '4px 8px', // Smaller padding for closer buttons
  fontSize: '12px', // Smaller font size
  backgroundColor: '#007BFF', // Default button color
  color: 'white',
  border: 'none',
  borderRadius: '4px',
  cursor: 'pointer',
  transition: 'background-color 0.2s ease',
};


export default DropdownExample;